(ns frontend.view.guest.view
  (:require [frontend.routing :as routing]
            [reagent.core :as r]
            [frontend.page-components.default-page-layout :as default-page-layout]))

(defn view
  []
  (r/create-class
   {:reagent-render
    (fn []
      [default-page-layout/view
       [:div.guest-view
        "This is guest home"]
       "zap-page guest"])}))

(defmethod routing/render-view :guest-home [_]
  [view])
